import React from 'react';
import { Helmet } from 'react-helmet';
import SocialMediaBranding from './SocialMediaBranding';

const SocialMediaBrandingPage = () => (
  <>
    <Helmet>
      <title>Social Media Branding | MilaajBrandset</title>
      <meta
        name="description"
        content="Boost your brand's presence with MilaajBrandset's social media branding services. Create a strong and recognizable brand identity online."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, social media branding, brand identity, online presence, brand recognition"
      />
      <meta property="og:title" content="Social Media Branding | MilaajBrandset" />
      <meta
        property="og:description"
        content="Boost your brand's presence with MilaajBrandset's social media branding services. Create a strong and recognizable brand identity online."
      />
    </Helmet>
    <SocialMediaBranding />
  </>
);

export default SocialMediaBrandingPage;